import {createSlice} from "@reduxjs/toolkit";

const initialPopupEditRowDataState = {
  dataLoading: false,
  entities: null,
  error: null,
};
export const callTypes = {
  data: "data",
  action: "action"
};

export const popupConfirmCustomerSlice = createSlice({
  name: "popupConfirmCustomer",
  initialState: initialPopupEditRowDataState,
  reducers: {
    popupConfirmCustomerDataFetched: (state, action) => {
      const {entities} = action.payload;
      state.dataLoading = false;
      state.error = null;
      state.entities = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoiceOrdersError = null;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
